import styled, { css } from 'styled-components'

import { colors } from 'app/theme/colors'

export { SubBlockContent as Content } from 'app/components/shared/dashboardSummaryStyles'

const breakpoint = '1024px'

export const Body = styled.div`
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  gap: 20px;

  .MuiDivider-root {
    width: 100%;
  }
`

export const RowFlexCenter = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  gap: 4px;

  .button-interaction {
    background-color: ${colors.ohOrange};
    text-transform: lowercase;
    font-weight: 600;
    font-family: 'AvenirDemi';
  }

  .button-interaction:hover {
    background-color: ${colors.ohDarkOrange};
  }
`

export const RowFlexSpace = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: row;
`

export const ColumnFlexCenter = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 4px;
`

export const ColumnFlexStart = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  gap: 20px;
`

export const InfoBlock = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: row;
  gap: 20px;
  width: 100%;
`

export const Icon = styled.img``

export const RowFlex = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 4px;
`
